/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdDomainModelsDBDBInviteInviteStatusErrorCodeFromJSON, FxIdDomainModelsDBDBInviteInviteStatusErrorCodeToJSON, } from './FxIdDomainModelsDBDBInviteInviteStatusErrorCode';
/**
 * Check if a given object implements the FxIdWebFeaturesInviteEmailInviteStatusResponse interface.
 */
export function instanceOfFxIdWebFeaturesInviteEmailInviteStatusResponse(value) {
    if (!('StatusCode' in value) || value['StatusCode'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesInviteEmailInviteStatusResponseFromJSON(json) {
    return FxIdWebFeaturesInviteEmailInviteStatusResponseFromJSONTyped(json, false);
}
export function FxIdWebFeaturesInviteEmailInviteStatusResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'StatusCode': FxIdDomainModelsDBDBInviteInviteStatusErrorCodeFromJSON(json['StatusCode']),
        'LoginToken': json['LoginToken'] == null ? undefined : json['LoginToken'],
    };
}
export function FxIdWebFeaturesInviteEmailInviteStatusResponseToJSON(json) {
    return FxIdWebFeaturesInviteEmailInviteStatusResponseToJSONTyped(json, false);
}
export function FxIdWebFeaturesInviteEmailInviteStatusResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'StatusCode': FxIdDomainModelsDBDBInviteInviteStatusErrorCodeToJSON(value['StatusCode']),
        'LoginToken': value['LoginToken'],
    };
}
//# sourceMappingURL=FxIdWebFeaturesInviteEmailInviteStatusResponse.js.map